<template>
  <modalDialog class="modal--personalized" @close="close">
    <p class="" slot="header">{{ $t("xpo.operations") }}</p>
    <div slot="form" class="form">
      <div class="detail" v-for="item in operations" :key="item.code">
        <p class="detail__title detail__title--operations">
          {{ item.description }}
        </p>
        <div class="detail__details">
          <div class="meter">
            <span :style="{ width: item.percentage + '%' }"
              ><i18n-n
                :value="item.percentage"
                v-if="item.percentage != null"
              />%</span
            >
          </div>
        </div>
        <div class="detail__details--sub-level">
          <div
            class="item"
            v-for="item2 in item.operationsDetails"
            :key="item2.code"
          >
            <span
              class="item__value item__value--download"
              v-on:click="openTab(item2.url)"
            >
              {{ item2.description }}
            </span>
            <div class="meter">
              <span :style="{ width: item2.percentage + '%' }"
                ><i18n-n
                  :value="item2.percentage"
                  v-if="item2.percentage != null"
                />%</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button cancel class="btn btn--white modal__btn" @click="close">
        {{ $t("global.button.close") }}
      </button>
    </div>
  </modalDialog>
</template>

<script>
import modalDialog from "@/components/ModalDialogFrame.vue";

export default {
  components: {
    modalDialog
  },
  props: {
    operations: {
      required: true
    }
  },
  name: "DialogOperations",
  data: () => ({}),
  methods: {
    close() {
      this.$emit("close");
    },
    openTab(url) {
      window.open(url);
    }
  },
  mounted() {
    this.$plausible.trackEvent("showOperations");
  }
};
</script>

<style scoped>
.detail__title--operations {
  background: url("./assets/articles.svg") no-repeat;
}
.item__value--download {
  cursor: pointer;
  background: url("./assets/download.svg") no-repeat;
}
.item {
  margin-bottom: 10px;
}
.item__value {
  padding: 0 0 0 25px;
}
.meter {
  grid-column: 1 / 3;
  background: #858585;
  justify-content: flex-start;
  border-radius: 100px;
  align-items: center;
  position: relative;
  padding: 0 2px;
  display: flex;
  height: 20px;
  width: 100%;
}
.meter > span {
  border-radius: 100px;
  background: #cc0000;
  height: 16px;
  color: #ffffff;
  text-align: center;
  font-size: 10px;
}

.form {
  max-height: 50vh;
  overflow-y: auto;
}
</style>
